import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ILoginActivitySlice } from "../../models/admin/loginActivity/loginActivity";
import {
  getLoginActivity,
  getLoginActivityByFilter,
} from "./loginActivityActions";

const initialState: ILoginActivitySlice = {
  loginActivity: [],
};

const loginActivitySlice = createSlice({
  name: "loginActivity",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLoginActivity.fulfilled, (state, { payload }) => {
      state.loginActivity = payload.data || [];
    });
    builder.addCase(
      getLoginActivityByFilter.fulfilled,
      (state, { payload }) => {
        state.loginActivity = payload.data || [];
      }
    );
  },
});

export default loginActivitySlice.reducer;
